import { linkHorizontal } from 'd3-shape';
import { ISankeyLink } from '../interfaces';

// cannot be arrow function because of first argument being this
function horizontalSource(link: ISankeyLink): [number, number] {
  return [link.source.x1, link.y0];
}

// cannot be arrow function because of first argument being this
function horizontalTarget(link: ISankeyLink): [number, number] {
  return [link.target.x0, link.y1];
}

export default () =>
  linkHorizontal<ISankeyLink, [number, number]>()
    .source(horizontalSource)
    .target(horizontalTarget);
